export default (theme) => ({
    menuButton: {
        color: "black",
        marginRight: 20,
    },
    title: {
        flexGrow: 1,
        color: "black",
    },
});
